module.exports = __webpack_public_path__ + "img/home-improvements-icon.fd9dcd34.svg";